@file:kotlin.js.JsExport
/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by omnia
 * On: 21/Jun/2026.
 */

package com.narbase.letsgo.web.routing.domain.passenger.sharedride

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.routing.domain.passenger.rides.PassengerRideDto

object GetSharedRideEndpoint : EndPoint<GetSharedRideEndpoint.Request, GetSharedRideEndpoint.Response>() {


    class Request (
        val token: String,
        val isFirstFetch: Boolean
    )

    class Response(
        val sharedRideDto: SharedRideDto?,
        val isOwnRide: Boolean,
        val ride: PassengerRideDto?
    )
}